<template>
  <div class="content">
    <div class="img-content fail">
      <div class="txt">请稍后再次尝试</div>
      <div class="txt txt-title">暂无适合您的问卷</div>
    </div>
  </div>
</template>

<script> 

export default {
}
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-content {
  height: 224px;
  width: 100%;
  align-self: stretch;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  position: relative;
}

.success {
  background: #E3696A url(../assets/img/success@2x.png) no-repeat center;
  background-size: 375px 224px;
}

.fail {
  background: #67AD73 url(../assets/img/fail@2x.png) no-repeat center;
  background-size: 375px 224px;
}

.cell-content {
  background: #F5F5F5;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-self: stretch;
  padding-top: 20px;
  padding-bottom: 20px;
}

.cell {
  display: flex;
  flex-direction: column;
  margin: 0 20px;
  background: white;
  padding: 20px;
  cursor: pointer;
  width: 30%;
}

.cell .title {
  font-size: 16px;
  color: #333;
}

.cell .subtitle {
  font-size: 12px;
  color: #999;
  margin-top: 20px;
}

.btn-content {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: #F5F5F5;
  padding-bottom: 20px;
}

.btn {
  color: white;
  background: #68AD73;
  font-size: 16px;
  width: 25%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}

.txt-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  background: #F5F5F5;
  padding-bottom: 20px;
}

.txt-space {
  flex-grow: 1;
}

.txt-content p {
  font-size: 14px;
  color: #999;
  line-height: 18px;
  flex-shrink: 0;
}

.txt {
  margin-bottom: 10px;
  color: white;
  font-size: 16px;
}

.txt-title {
  font-size: 18px;
}

.bulbs-card {
  width: 100%;
  background: #F5F5F5;
  /* display: flex;
  flex-direction: row;
  justify-content: center; */
}

.bulbs-inside {
  background: white;
  width: 25%;
  margin: 10px auto;
}
</style>
